<script>
	import { projectSettings } from '../../config';
	import { pageNumber, model } from '../../stores';
	import { getTealiumID } from '../../tealium';

	import Holding from '../../models/Holding';
	import Input from '../../components/Input.svelte';
	import NumberInput from '../../components/NumberInput.svelte';
	import NavigationButtons from '../../components/NavigationButtons.svelte';
	import ClassActionEmailAddress from '../../components/ClassActionEmailAddress.svelte';
	import ClassActionPhoneNumber from '../../components/ClassActionPhoneNumber.svelte';
	import Transactions from './Transactions.svelte';

	// props
	export let title = null;
	export let pageIndex = null;
	export let nextPage = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let disabled = false;
	export let lastVisitedPage = null;

	// component state updating
	if (!disabled) {
		$pageNumber = pageIndex;
		$model.LastPageVisited = lastVisitedPage;
		document.title = `${projectSettings.classActionName} - Holdings`;
		$model.TealiumId = $model.TealiumId || getTealiumID();
	}

	// list management
	if ($model.Holdings.length === 0) $model.Holdings = [new Holding()];
</script>

{#if $model.alreadySubmitted}
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1>Thank you</h1>

			<p>
				You have already completed your additional information form for the {projectSettings.classActionName}.
			</p>

			<p>
				Your reference number is: <strong>{$model.RegistrationNumber}</strong>
			</p>

			<p>
				If you have any questions, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber>, or at <ClassActionEmailAddress
				></ClassActionEmailAddress> and quote the registration number above.
			</p>
		</div>
	</div>
{:else}
	<section>
		<h1>Holding Details</h1>
		<p>Please confirm your initial holdings as at close of trade 18/12/2020.</p>

		{#each $model.Holdings as holding, i}
			<div class="panelWrapper">
				<div class="row">
					<div class="col-sm-6">
						<Input
							bind:value={holding.HoldingName}
							label={'Name of Holding'}
							id="HoldingName_{i}"
							maxLength={'8000'}
							disabled />
					</div>
					<div class="col-sm-6">
						<Input
							bind:value={holding.RegisteredOwner}
							label={'Registered Owner'}
							id="RegisteredOwner_{i}"
							maxLength={'8000'}
							disabled />
					</div>
					<div class="col-sm-6">
						<Input
							bind:value={holding.HoldingIdentificationNumber}
							label={'SRN/HIN (Australian shareholder only, if known)'}
							id="HoldingIdentificationNumber_{i}"
							maxLength={'25'}
							disabled />
					</div>
					<div class="col-sm-6">
						<NumberInput
							bind:value={holding.InitialHoldings}
							label="Securities held at close of trade on 18 December 2020"
							id="InitialHoldings_{i}"
							required
							{disabled} />
					</div>
				</div>

				<Transactions transactions={holding.HoldingTransactions} />
			</div>
		{/each}

		{#if !disabled}
			<div class="form-group form-row">
				<div class="col-md-12 last">
					<NavigationButtons
						{persistUrl}
						showPrevious="false"
						{nextPage}
						nextPageLabel="Submit"
						pageName={title}></NavigationButtons>
				</div>
			</div>
		{/if}
	</section>
{/if}

<style>
	.panelWrapper {
		background-color: var(--white);
		border-radius: 5px;
		padding: 20px;
		margin-bottom: 20px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}
</style>
